/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentForTakeoverResponse
 */
export interface AppointmentForTakeoverResponse {
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentForTakeoverResponse
     */
    startTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppointmentForTakeoverResponse
     */
    endTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentForTakeoverResponse
     */
    isAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    clientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    clientFirstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    clientLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    assignedCounselorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    assignedCounselorUserCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    previousCounselorId: string | null;
    /**
     * 
     * @type {string}
     * @memberof AppointmentForTakeoverResponse
     */
    previousCounselorUserCode: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentForTakeoverResponse
     */
    isMarkedForTakeover: boolean;
}

/**
 * Check if a given object implements the AppointmentForTakeoverResponse interface.
 */
export function instanceOfAppointmentForTakeoverResponse(value: object): value is AppointmentForTakeoverResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('startTimeUtc' in value) || value['startTimeUtc'] === undefined) return false;
    if (!('endTimeUtc' in value) || value['endTimeUtc'] === undefined) return false;
    if (!('isAllDay' in value) || value['isAllDay'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientFirstName' in value) || value['clientFirstName'] === undefined) return false;
    if (!('clientLastName' in value) || value['clientLastName'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('assignedCounselorUserCode' in value) || value['assignedCounselorUserCode'] === undefined) return false;
    if (!('previousCounselorId' in value) || value['previousCounselorId'] === undefined) return false;
    if (!('previousCounselorUserCode' in value) || value['previousCounselorUserCode'] === undefined) return false;
    if (!('isMarkedForTakeover' in value) || value['isMarkedForTakeover'] === undefined) return false;
    return true;
}

export function AppointmentForTakeoverResponseFromJSON(json: any): AppointmentForTakeoverResponse {
    return AppointmentForTakeoverResponseFromJSONTyped(json, false);
}

export function AppointmentForTakeoverResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentForTakeoverResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'startTimeUtc': (new Date(json['startTimeUtc'])),
        'endTimeUtc': (new Date(json['endTimeUtc'])),
        'isAllDay': json['isAllDay'],
        'purposeKey': json['purposeKey'],
        'location': json['location'],
        'details': json['details'],
        'clientId': json['clientId'],
        'clientFirstName': json['clientFirstName'],
        'clientLastName': json['clientLastName'],
        'assignedCounselorId': json['assignedCounselorId'],
        'assignedCounselorUserCode': json['assignedCounselorUserCode'],
        'previousCounselorId': json['previousCounselorId'],
        'previousCounselorUserCode': json['previousCounselorUserCode'],
        'isMarkedForTakeover': json['isMarkedForTakeover'],
    };
}

export function AppointmentForTakeoverResponseToJSON(json: any): AppointmentForTakeoverResponse {
    return AppointmentForTakeoverResponseToJSONTyped(json, false);
}

export function AppointmentForTakeoverResponseToJSONTyped(value?: AppointmentForTakeoverResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'startTimeUtc': value['startTimeUtc'].toISOString(),
        'endTimeUtc': value['endTimeUtc'].toISOString(),
        'isAllDay': value['isAllDay'],
        'purposeKey': value['purposeKey'],
        'location': value['location'],
        'details': value['details'],
        'clientId': value['clientId'],
        'clientFirstName': value['clientFirstName'],
        'clientLastName': value['clientLastName'],
        'assignedCounselorId': value['assignedCounselorId'],
        'assignedCounselorUserCode': value['assignedCounselorUserCode'],
        'previousCounselorId': value['previousCounselorId'],
        'previousCounselorUserCode': value['previousCounselorUserCode'],
        'isMarkedForTakeover': value['isMarkedForTakeover'],
    };
}

